import { ReactNode } from "react";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "@tellescope/ui";
import { RouterContent } from "./RouterContent";
import { TellescopeTanstackQueryProvider } from "../components";
import { AuthProvider } from "../providers/AuthProvider";
import { PendoProvider } from "../providers/PendoProvider";
import { WebappSetupDialogProvider } from "../providers/WebappSetupDialogProvider";
import { AuthenticatedSidebarPanel } from "./AuthenticatedSidebarPanel";
import { ErrorBoundary } from "../components/ErrorBoundary";

export interface RouterProps {
  children?: ReactNode;
}

export const Router = ({ children }: RouterProps) => {
  const basename = import.meta.env.BASE_URL.replace(/\/$/, "");

  return (
    <BrowserRouter basename={basename}>
      <AuthProvider>
        <PendoProvider>
          <TellescopeTanstackQueryProvider>
            <WebappSetupDialogProvider>
              {/* App shell: routed content and the sidebar are flex siblings, so the sidebar
                  reserves its own width on every route and content lays out beside it. The sidebar
                  is mounted once here (not inside per-route MainLayout) so it persists across
                  navigation — no remount, so its open/selected-block/scroll state survives.

                  The sidebar gets its own ErrorBoundary. It is mounted at the shell rather than under a
                  route, so an uncaught throw from any block type would otherwise unmount every route —
                  and because the panel's open state is persisted, it would reproduce on reload, leaving
                  the app unusable. The boundary confines the failure to the panel and leaves the routed
                  page working. */}
              <div className="flex w-full min-h-screen">
                <div className="flex-1 min-w-0">
                  <RouterContent />
                </div>
                <ErrorBoundary>
                  <AuthenticatedSidebarPanel />
                </ErrorBoundary>
              </div>
              <Toaster />
            </WebappSetupDialogProvider>
          </TellescopeTanstackQueryProvider>
          {children}
        </PendoProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};
